import PropTypes from 'prop-types';
import classNames from 'classnames';
import { appVersionLabel, brandCopyrightLabel, brandThanksUsingLabel } from '../../config/branding';

/**
 * 工作台品牌页脚：对齐 Falcon（左感谢语 | 版权，右版本号）。
 */
const AppBrandFooter = ({ className }) => {
	const thanks = brandThanksUsingLabel();
	const copyright = brandCopyrightLabel();
	const version = appVersionLabel();
	const ariaLabel = `${thanks} ${copyright} ${version}`;

	return (
		<footer className={classNames('app-brand-footer', className)} aria-label={ariaLabel}>
			<div className='app-brand-footer__rule' aria-hidden='true' />
			<div className='app-brand-footer__row'>
				<div className='app-brand-footer__meta'>
					<span className='app-brand-footer__product'>{thanks}</span>
					<span className='app-brand-footer__sep' aria-hidden='true'>
						|
					</span>
					<span className='app-brand-footer__copyright'>{copyright}</span>
				</div>
				<span className='app-brand-footer__version user-select-all' title='可选中复制版本号'>
					{version}
				</span>
			</div>
		</footer>
	);
};

AppBrandFooter.propTypes = {
	className: PropTypes.string,
};

export default AppBrandFooter;
